import React from "react";
import AmountInput from "../AmountInput";
import CombinedConverter from "../Convert";
import ConversionButton from "../ConversionButton";
import { AppState, TxStatus } from "../../../types/types";

import leftImage from "../../../assets/img/img-hero-l.webp";
import rightImage from "../../../assets/img/img-hero-r.webp";

type BurnMintTabProps = {
  appState: AppState;
  setAppState: React.Dispatch<React.SetStateAction<AppState>>;
  sliderRatio: number;
  setSliderRatio: React.Dispatch<React.SetStateAction<number>>;
  onTransactionSuccess: () => void;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setModalTx: React.Dispatch<
    React.SetStateAction<{
      txStatus: TxStatus;
      txHash: string | null;
    }>
  >;
};

const BurnMintTab: React.FC<BurnMintTabProps> = ({
  appState,
  setAppState,
  sliderRatio,
  setSliderRatio,
  onTransactionSuccess,
  setShowModal,
  setModalTx,
}) => {
  return (
    <div className="w-full h-full flex flex-col gap-2 px-5">
      {/* Top title and decorative images */}
      <div className="flex flex-col ">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 mb-4">
          <img
            src={leftImage}
            alt="Hero decorative left"
            width={256}
            height={256}
            className="z-[3] w-16 md:w-20 animate-fade-in-up"
          />
          <h2 className="text-xl sm:text-4xl font-bold text-primary-dark text-center">
            BURN &amp; MINT
          </h2>
          <img
            src={rightImage}
            alt="Hero decorative right"
            width={256}
            height={256}
            className="z-[3] w-16 md:w-20 animate-fade-in-up"
          />
        </div>
        <div className="max-w-2xl">
          <p className="text-[12px] font-bold  text-gray-600 text-center mb-4">
            Burn NAU and choose how much you want to convert into NAUY(Yes) or
            NAUN (No) based on your opinion.{" "}
          </p>
        </div>
      </div>
      {/* Middle section: input + converter */}
      <div className="flex flex-col gap-6">
        <AmountInput
          amountNAU={appState.amountNAU}
          onAmountChange={(newAmount) =>
            setAppState((prev) => ({ ...prev, amountNAU: newAmount }))
          }
          loading={appState.loading}
          remainingBalance={parseFloat(appState.balance) - appState.amountNAU}
        />

        <CombinedConverter
          conversionRatio={sliderRatio}
          onRatioChange={setSliderRatio}
          loading={appState.loading}
          convertedAmountNAUY={appState.convertedAmountNAUY}
          convertedAmountNAUN={appState.convertedAmountNAUN}
          error={appState.error}
        />
      </div>
      {/* Bottom section: conversion button */}
      <div className="mt-auto">
        <ConversionButton
          state={appState}
          setState={setAppState}
          conversionRatio={appState.conversionRatio}
          loading={appState.loading}
          balanceNAU={appState.balance}
          amountNAU={appState.amountNAU}
          setShowModal={setShowModal}
          onTransactionSuccess={onTransactionSuccess}
          setModalTx={setModalTx}
        />
      </div>
    </div>
  );
};

export default BurnMintTab;
